export const formatPlanLimit = (value) => (
  value === null || value === undefined || value === "" ? "Unlimited" : value
);

export const formatAiRequestLimit = (value) => {
  const numericValue = Number(value || 0);

  if (numericValue > 0) {
    return `${numericValue} request${numericValue !== 1 ? "s" : ""} / month`;
  }

  return "Included in your subscription";
};

export const getAiFeatures = (plan = {}) => {
  const features = [
    {
      key: "ai_chatbot",
      enabled: Boolean(plan.ai_chatbot),
      label: "AI Dispatcher Chat",
      description: "Ask the AI assistant for operational support and dispatch guidance.",
      limit: formatAiRequestLimit(plan.ai_chatbot_requests),
    },
    {
      key: "ai_load_creation",
      enabled: Boolean(plan.ai_load_creation),
      label: "AI Load Creation",
      description: "Generate loads faster with AI-assisted creation workflows.",
      limit: formatAiRequestLimit(plan.ai_load_creation_requests),
    },
    {
      key: "ai_truck_prediction",
      enabled: Boolean(plan.ai_truck_prediction),
      label: "AI Maintenance Prediction",
      description: "Use AI predictions to anticipate truck maintenance needs.",
      limit: formatAiRequestLimit(plan.ai_truck_prediction_requests),
    },
  ];

  return {
    included: features.filter((feature) => feature.enabled),
    excluded: features.filter((feature) => !feature.enabled),
    all: features,
  };
};

const normalizeLimit = (value) => (
  value === null || value === undefined || value === "" ? null : Number(value)
);

export const getPlanDowngradeImpact = (plan = {}, usageFeatures = {}) => {
  const checks = [
    {
      key: "users",
      label: "users",
      used: Number(usageFeatures?.users?.used || 0),
      limit: normalizeLimit(plan.users),
    },
    {
      key: "trucks",
      label: "trucks",
      used: Number(usageFeatures?.trucks?.used || 0),
      limit: normalizeLimit(plan.trucks),
    },
  ];

  const impacted = checks
    .filter((item) => item.limit !== null && item.used > item.limit)
    .map((item) => ({
      ...item,
      overBy: item.used - item.limit,
    }));

  return {
    impacted,
    hasImpact: impacted.length > 0,
  };
};

export const getDowngradeAdjustmentMessage = (impacted = []) => {
  if (!impacted.length) {
    return "";
  }

  const summary = impacted
    .map((item) => `${item.overBy} ${item.label}`)
    .join(" and ");

  return `Before switching to this plan, you must reduce ${summary}.`;
};
